import React, { useState, useEffect } from "react";
import plusWhite from "../../assets/images/plus-white.svg";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "../../styles/style.css";
import "../../styles/payout.css";
import "../../styles/upi-mandate.css";
import { TabPanel, Tabs } from "react-tabs";
import trashIcon from "../../assets/images/trash-03.svg";
import editIcon from "../../assets/images/edit-02.svg";
import viewIcon from "../../assets/images/eye-02.png";
import Pagination from "../../components/pagination/paginationView";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { Loader } from "../../components/loader";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { SingleErrorMessage } from "../singleErrorMessage";
import { Modal, Offcanvas } from "react-bootstrap";
import {
  deleteReel,
  fetchReelDetails,
  getShortsList,
} from "../../action/shorts";

const ShortsList = () => {
  const location = useLocation();
  const [list, setList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(location.state ?? 1);
  const [totalData, setTotalData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [reelId, setReelId] = useState("");
  const [deleteModel, setDeleteModel] = useState(false);
  const [showReelModel, setShowReelModel] = useState(false);
  const [data, setData] = useState({});

  const getList = async (page) => {
    try {
      setIsLoading(true);
      const response = await getShortsList(page, pageSize); // Adjust 10 to the desired number of items per page
      if (response.status) {
        setList(response.data.feedDetails);
        setTotalData(response.data.count);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };

  const onCloseToaste = () => {
    toast.dismiss();
  };

  const getReelDetails = async (id) => {
    try {
      const response = await fetchReelDetails(id);
      if (response.status) {
        setData(response.data.feedDetails[0]);
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };

  const handleDelete = async () => {
    const response = await deleteReel(reelId);
    if (response.status) {
      toast.custom(
        <SingleErrorMessage
          data={response.message}
          error={false}
          bColor="#175FC9"
          onClose={onCloseToaste}
        />
      );
      setDeleteModel(false);
      getList(pageNo);
    } else {
      toast.custom(
        <SingleErrorMessage
          data={response.message}
          error={true}
          bColor="#D92D20"
          onClose={onCloseToaste}
        />
      );
    }
    setReelId("");
  };
  useEffect(() => {
    getList(pageNo);
  }, [pageNo, pageSize]);
  return (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="">
              {" "}
              <Breadcrumb paths={[{ name: "Shorts" }]} />
            </div>
          </div>
          <Link
            className="btn btn-info addbbtn"
            color="info"
            to={"/shorts/add"}
            state={pageNo}
          >
            Create New +

          </Link>
        </div>
      </div>
      <div className="tab_box">
        <Tabs>
          <TabPanel>
            <div className="payout_inner_content">
              <table className="payout_table upi-mandate_table">
                <thead>
                  <tr className="tableHead">
                    <th className="thHeader">
                      <div className="payoutHead hndIcon">Description</div>
                    </th>
                    <th className="thHeader" style={{ width: "10%" }}>
                      <div className="payoutHead hndIcon">Date</div>
                    </th>
                    <th className="thHeader" style={{ width: "10%" }}>
                      <div className="payoutHead hndIcon">Action</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="15">
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list?.length > 0 ? (
                        list?.map((item) => (
                          <tr key={item._id}>
                            <td>{item?.desc}</td>
                            <td>
                              {moment(item?.createdAt).format("DD/MM/YYYY")}
                            </td>
                            <td className="three_btn">
                            <Link
                                to={`/contest/list/${item._id}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowReelModel(true);
                                  getReelDetails(item._id);
                                }}
                              >
                                <img src={viewIcon} alt="/" />
                              </Link>
                              {/* <Link
                                to={`/module/edit/${item._id}`}
                                state={pageNo}>
                                <img
                                  src={editIcon}
                                  alt="Edit icon"
                                />
                              </Link> */}

                              <Link
                                className="dlt_btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setDeleteModel(true);
                                  setReelId(item._id);
                                }}
                              >
                                <img
                                  src={trashIcon}
                                  style={{
                                    height: "26px",
                                  }}
                                  alt="delete icon"
                                />
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="15" className="text_center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </TabPanel>
        </Tabs>

        {list.length > 0 && (
          <>
            <Pagination
              currentPage={pageNo}
              totalCount={totalData}
              pageSize={pageSize}
              onPageChange={(page) => setPageNo(page)}
              changePageSize={(page) => {
                setPageSize(page);
                setPageNo(1);
              }}
            />
          </>
        )}
      </div>

      <Offcanvas
        show={showReelModel}
        onHide={() => {
          setShowReelModel(false);
        }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Shorts Video</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="add_buyer_content">
            <div className="row">
              <div className="col-lg-12">
                {/* VIDEO PREVIEW */}
                <div className="input-box">
                  <div className="input-label">Video Preview</div>

                  {data?.reel?.assets?.mp4 ? (
                    <video
                      width="100%"
                      height="200"
                      controls
                      style={{ borderRadius: "10px" }}
                    >
                      <source src={data?.reel?.assets?.mp4} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <p>No video available</p>
                  )}
                </div>

                {/* Title Field */}
                <div className="input-box">
                  <div className="input-label">Caption Title (English)</div>
                  <div className="input_field">
                    <textarea
                      className="input"
                      name="desc.en"
                      placeholder="Enter caption"
                      value={data?.desc?.en}
                      rows={3}
                    />
                  </div>
                </div>
                <div className="input-box">
                  <div className="input-label">Caption Title (Hindi)</div>
                  <div className="input_field">
                    <textarea
                      className="input"
                      name="desc.hi"
                      placeholder="Enter caption"
                      value={data?.desc?.hi}
                      rows={3}
                    />
                  </div>
                </div>
                <div className="input-box">
                  <div className="input-label">Caption Title (Marathi)</div>
                  <div className="input_field">
                    <textarea
                      className="input"
                      name="desc.mr"
                      placeholder="Enter caption"
                      value={data?.desc?.mr}
                      rows={3}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Modal
        show={deleteModel}
        onHide={() => {
          setDeleteModel(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete the shorts video</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this shorts video?
        </Modal.Body>
        <Modal.Footer>
          <button
            variant="secondary"
            className="btn btn-dark"
            onClick={() => {
              setDeleteModel(false);
            }}
          >
            No
          </button>
          <button
            className="btn btn-success"
            variant="primary"
            onClick={() => {
              handleDelete();
            }}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ShortsList;
